import s from "./whatsAppRedirect.module.css";
import {iconWhatsappWhite} from "../../assets";
import {useWhatsAppRedirect} from "./useWhatsAppRedirect";

const WhatsAppRedirect = () => {
    // Component logic data
    const componentProps = useWhatsAppRedirect();

    // Destructured component logic data
    const {data} = componentProps;

    // Error prevention clause
    if (!data) {
        return null;
    }

    // Both fields MUST exist for the component to work
    if (!data.enabled || !data.url) {
        console.warn("No data available for WhatsAppRedirect");

        return null;
    }

    return (
        <div className={`font-museo ${s.root}`}>
            <a
                href={data.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className={`${s.anchor}`}
            >
                <img
                    src={iconWhatsappWhite}
                    alt="WhatsApp Icon"
                />
                <div className={`${s.textBlock}`}>
                    <h1>
                        Posso ajudar?
                    </h1>
                    <p>
                        Acesse nosso assistente virtual
                    </p>
                </div>
            </a>
        </div>
    )
}

export default WhatsAppRedirect;
